import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './EvTaskDescriptEditor.html?raw';
import on from 'dojo/on';
import Edit from '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
//import SearchSelect = require("../../../moreCore/UI/SearchSelect/SearchSelect");
import AddressEntry from './Addresses/AddressEntry';
import SelectEntityDialog from '../../../moreCore/UI/SelectEntityDialog/SelectEntityDialog';
import "../../../moreCore/UI/SelectEntityDialog/SelectEntityDialog";
import { MainCatalogSelect } from '../MainCatalogEditorTools';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";

class EvTaskDescriptEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    dt_Input_TaskGroup: MdsLax<InstanceType<typeof MainCatalogSelect>>;

    dt_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    dt_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    dt_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    dt_Checkbox_Active: MdsLax<InstanceType<typeof CheckBox>>;

    dt_Input_time_forerun: MdsLax<InstanceType<typeof NumberInput>>;
    dt_Input_time_trailer: MdsLax<InstanceType<typeof NumberInput>>;

    allAddressEntries: Array<MdsLax<InstanceType<typeof AddressEntry>>>;

    addressesButtonAdd: HTMLButtonElement;
    addressesContainer: HTMLDivElement;

    selectEntityDlg: MdsLax<InstanceType<typeof SelectEntityDialog<any>>>;

    formData: MainCatalogTypes.EvTaskDescript_SaveData = {
        ID: "",
        is_new_status: null,
        Classname: "",
        code: "",
        description: "",
        is_active: null,
        time_forerun: null,
        time_trailer: null,
        order: null,
        ev_task_grp_id: null,
        addresses: []
    };

    prepareFormData(data?: MainCatalogTypes.EvTaskDescript_LoadData): void {

        let taskGrp = null;
        this.allAddressEntries = new Array<MdsLax<InstanceType<typeof AddressEntry>>>();
        this.UiModder.domConstruct.empty(this.addressesContainer);
        if (data) {
            //this.dt_Input_TaskGroup._loadListValues(data.ref_task_grp, true);
            this.dt_Input_TaskGroup.setCatalog(MainCatalogs_Classes.EvTaskDescriptGroup,
                this.translations["General_Label_EvTaskDescriptGroup"], true, data.ref_task_grp.ID);

            taskGrp = data.ref_task_grp.ID;

            this.dt_Input_Code.setValue(data.code, true);
            this.dt_Input_Description.setValue(data.description_D, true);
            this.dt_Input_Order.setValue(data.order, true);

            this.dt_Checkbox_Active.setValue(data.is_active, true);

            this.dt_Input_time_forerun.setValue(data.time_forerun, true);
            this.dt_Input_time_trailer.setValue(data.time_trailer, true);

           
            
            //this.UiModder.domClass.add(this.dt_Input_Classname.scrollContainer, "w3-2018-coconut-milk");

            data.addresses.forEach(adr => {

                let entry = new AddressEntry();
                entry.setEntry(false, adr);
                entry.placeAt(this.addressesContainer);
                on(entry, "Addresses_SerializeData", lang.hitch(this, this._onChangeInputDataGeneric));

                this.UiModder.domClass.add(entry.domNode, "mds-bg-green accentOutline round w3-margin");

                this.allAddressEntries.push(entry);
            });

            this.formData.ID = data.ID;
            
            this.formData.is_new_status = false;
        } else {

            this.dt_Input_Code.setValue("", true);
            this.dt_Input_Description.setValue("", true);
            this.dt_Input_Order.setValue(null, true);

            this.dt_Checkbox_Active.setValue(true, true);

            this.dt_Input_time_forerun.setValue(null, true);
            this.dt_Input_time_trailer.setValue(null, true);

            //this.dt_Input_TaskGroup._loadListValues();
            this.dt_Input_TaskGroup.setCatalog(MainCatalogs_Classes.EvTaskDescriptGroup,
                this.translations["General_Label_EvTaskDescriptGroup"], true);
            this.dt_Input_TaskGroup.setValue(null);


            //this.UiModder.domClass.add(this.dt_Input_Classname.scrollContainer, "w3-2018-coconut-milk");

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        if (this.dt_Input_TaskGroup) {
            this.dt_Input_TaskGroup.setEditButtonVisibility(true);
        }

        this.serializeFormData(taskGrp);
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    _onClickButtonAddressesButtonAdd(evt: MouseEvent, mode: number = 0) {

        let data = { "mode": mode };

        let url = window.appRoot + "MainCatalogsEditor/GetSEDconfig";
        this.StandbyStart();
        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onGetDlgConfig),
            lang.hitch(this, this._onGetDlgConfigError),
            false // sync
        );
    }

    _onGetDlgConfig(data: any) {
        this.selectEntityDlg = new SelectEntityDialog();
        let dlg = this.selectEntityDlg;
        dlg.setConfiguration(data, lang.hitch(this, this._onCallback_Dlg));
        //dlg.setValues(this.previousSEDvalue);
        dlg.show();
        this.StandbyStop();
    }

    _onGetDlgConfigError(error: more.requestErrorMessage) {
        console.log("error", error)
        alert(error.Message);
    }

    _onCallback_Dlg(data, items) {
        //this.previousSEDvalue = items;

        items.forEach(item => {
            let entity = {
                ID: item.entry.value, gDisp_1: item.entry.label
            }

            let entry = new AddressEntry();
            entry.setEntry(true, entity);
            entry.placeAt(this.addressesContainer);
            on(entry, "Addresses_SerializeData", lang.hitch(this, this._onChangeInputDataGeneric));
            on(entry, "Addresses_Destroy", lang.hitch(this, this._onDestroyAddress, entry));

            this.allAddressEntries.push(entry);
        })

        this.serializeFormData();
        this.checkDirty();
    }

    _onDestroyAddress(entry) {

        let index = this.allAddressEntries.indexOf(entry);

        this.allAddressEntries.splice(index, 1);

        this.serializeFormData();
        this.checkDirty();
    }

    serializeFormData(taskGrp?: string): void {

        this.formData.code = this.dt_Input_Code.getValue();
        this.formData.description = this.dt_Input_Description.getValue();

        this.formData.is_active = this.dt_Checkbox_Active.getValue();

        this.formData.time_forerun = this.dt_Input_time_forerun.getValue();
        this.formData.time_trailer = this.dt_Input_time_trailer.getValue();
        this.formData.ev_task_grp_id = this.dt_Input_TaskGroup.getValue();

        //className ? this.formData.Classname = className : this.formData.Classname = this.dt_Input_TaskGroup.getValue();
        taskGrp ? this.formData.ev_task_grp_id = taskGrp : this.formData.ev_task_grp_id = this.dt_Input_TaskGroup.getValue();

        this.formData.order = this.dt_Input_Order.getValue();

        this.formData.addresses = [];
        this.allAddressEntries.forEach(sub => {

            this.formData.addresses.push(sub.formData);
        });

        console.debug("SERIALIZED DATA", this.formData);
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.code) b = false;

        if (!this.formData.description) b = false;

        //if (!this.formData.ev_task_grp_id) {

        //    this.indicateErrorOnInput(this.dt_Input_TaskGroup.outerInput);
        //    b = false;
        //}
        if (!this.formData.ev_task_grp_id) {

            this.indicateErrorOnInput(this.dt_Input_TaskGroup.catalogLabelContainer, "w3-red");
            b = false;
        }

        this.__delayDisableSaveButton(!b);

        return b;
    }

    _onChangeTaskGroupInputData() {
        this.serializeFormData();
        this.checkDirty();
    }

    closeMainGroupEdit(): void {

        this.dt_Input_TaskGroup.editForm?.close();
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.EvTaskDescript;

        //this.UiModder.domAttr.set(this.dt_Input_TaskGroup.outerInput, "placeholder", this.translations["MainCatalogsEditor_Placeholder_TaskGrp"]);

        this.dt_Input_TaskGroup.placeAt(this.editFormLeftSection, "last");
        this.UiModder.domClass.add(this.dt_Input_TaskGroup.domNode, "w3-margin-left w3-margin-right sectionBG overflow");
        //this.UiModder.domClass.remove(this.dt_Input_TaskGroup.catalogButtonShowEdit, "w3-hide");

        on(this.dt_Input_TaskGroup, "change", lang.hitch(this, this._onChangeInputDataGeneric));

        on(this, "MainCatalogSelect_ShowHideAddChange", lang.hitch(this, this.closeMainGroupEdit));
        on(this, "CatalogEntityData_Save", lang.hitch(this, this.closeMainGroupEdit));

        this.dt_Input_Code.setMaxLength(10);
        this.dt_Input_Description.setMaxLength(255);
        this.dt_Input_time_forerun.setNumberType("decimal");
        this.dt_Input_time_forerun.setUnit("min");
        this.dt_Input_time_trailer.setNumberType("decimal");
        this.dt_Input_time_trailer.setUnit("min");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(EvTaskDescriptEditor.prototype, {
  dt_Input_TaskGroup: () => (new MainCatalogSelect()),
  dt_Input_Code: () => (new Edit()),
  dt_Input_Description: () => (new Edit()),
  dt_Input_Order: () => (new NumberInput()),
  dt_Checkbox_Active: () => (new CheckBox()),
  dt_Input_time_forerun: () => (new NumberInput()),
  dt_Input_time_trailer: () => (new NumberInput()),
});
export default mdsWidget(EvTaskDescriptEditor);
